import { EventInput } from "@fullcalendar/core";
import { Schedule, ScheduleQuery } from "apis/ScheduleAPI";
import dayjs from "dayjs";
import SportCourtReduxWorker from "store/workers/SportCourtReduxWorker";
import {
  EVENT_STYLES,
  EVENT_STYLES_CANCELED,
  EVENT_STYLES_PAID,
} from "../event-utils";
import { CalendarQuery, CalendarViewRange } from "../context/utils";

const QUERY_LIMIT = 30;

export function formatQuery(
  currentViewRange: CalendarViewRange,
  query: CalendarQuery = { sportCourtId: [] }
): ScheduleQuery {
  const { sportCourtId, ...restQuery } = query;

  return {
    limit: QUERY_LIMIT,
    query: {
      ...restQuery,
      from: currentViewRange.start,
      to: currentViewRange.end,
      ...(sportCourtId && sportCourtId.length > 0 ? { sportCourtId } : {}),
    },
    page: 0,
  };
}

export function eventFormatter(event: Schedule): EventInput {
  const sportCourtName = SportCourtReduxWorker.getSportCourtNameById(
    event.rentalData.sportCourtId
  );

  const title = event.contactName + " - " + sportCourtName;

  const [start, end] = event.timeFromTo.split(" - ");
  const [hourStartRaw, minuteStartRaw] = start.split(":");
  const [hourEndRaw, minuteEndRaw] = end.split(":");
  const hourStart = Number(hourStartRaw);
  const minuteStart = Number(minuteStartRaw);
  const hourEnd = Number(hourEndRaw);
  const minuteEnd = Number(minuteEndRaw);

  const dateStart = dayjs(event.whenDate)
    .hour(hourStart)
    .minute(minuteStart)
    .second(0);
  const dateEnd = dayjs(event.whenDate)
    .hour(hourEnd)
    .minute(minuteEnd)
    .second(0);

  const style = getEventStyles(event);

  return {
    id: String(event.id),
    title: title,
    start: dateStart.format("YYYY-MM-DDTHH:mm:ss"),
    end: dateEnd.format("YYYY-MM-DDTHH:mm:ss"),
    type: event.type,
    status: event.status,
    backgroundColor: style.backgroundColor,
    textColor: style.textColor,
    borderColor: style.borderColor,
    classNames: style.classNames,
  };
}

function getEventStyles(event: Schedule) {
  switch (event.status) {
    case "CANCELED":
      return EVENT_STYLES_CANCELED;
    case "PAID":
      return EVENT_STYLES_PAID;
    default:
      return EVENT_STYLES;
  }
}
